<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="linksData">
    <div v-if="linksData.code === 500" class="cms-error">
      <span>{{ $t('not_cms') }}</span>
    </div>
    <div v-else class="links-page has-side-bars">
      <span class="links-title" v-html="linksData[0].title" />
      <div v-cms="linksData[0].htmldefinition" class="links-def" />
    </div>
  </div>
  <div v-else>
    <Loader :text="$t('loading')" />
  </div>
</template>

<script>
import { vCmsHtml as cms, getCMSWebpages } from '@/services/graphql'
import Loader from '../components/Loader.vue'

export default {
  components: { Loader },
  directives: { cms },
  props: {},
  asyncComputed: {
    linksData() {
      return getCMSWebpages(this.$store.state.i18n.lang, 'links')
    },
  },
}
</script>

<style lang="stylus" scoped>
.links-page
  display: flex
  flex-direction: column
  margin-top: vw(30px)
  margin-bottom: vw(20px)
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))
  gap: vw(6px)

  .links-def
    margin-top: vw(5px)
    m-font-size(16, 24)
    color: $grey-dark

    >>> a
      color: $corporate_color
      text-decoration: none

      &:hover
        color: $corporate_color
        text-decoration: underline
        cursor: pointer

    >>> li
      margin-left: vw(20px)
      padding: 0
      list-style-type: disc
    
  .links-title
    m-font-size(30, 34)
    color: black
    font-weight: 600

.cms-error
  display: flex
  justify-content: center
  align-items: center
  min-height: vw(200px)

  span
    m-font-size(20, 26)
    color: black
    font-weight: 400
</style>
